import React from "react";
import { Card, Checkbox } from "antd";
import { BriefAddon, BRIEF_ADDON_LABELS } from "../../../types/BuyerBriefTypes";

interface Props {
    selectedAddons: BriefAddon[];
    onChange: (addons: BriefAddon[]) => void;
}

const ADDON_DESCRIPTIONS: Record<BriefAddon, string> = {
    [BriefAddon.ESG_SUSTAINABILITY]:
        "Comprehensive environmental, social, and governance analysis including carbon footprint, diversity metrics, and sustainability commitments.",
    [BriefAddon.PARTNERSHIP_ECOSYSTEM]:
        "Assessment of the supplier's partner network, strategic alliances, technology integrations, and ecosystem dependencies.",
    [BriefAddon.CUSTOMER_CHURN_RETENTION]:
        "Analysis of customer retention patterns, churn indicators, contract renewal rates, and client satisfaction trends.",
    [BriefAddon.CASE_STUDIES_REFERENCES]:
        "Review of published case studies, customer references, testimonials, and documented success stories.",
};

const AddonSelectionStep: React.FC<Props> = ({ selectedAddons, onChange }) => {
    const handleToggle = (addon: BriefAddon) => {
        if (selectedAddons.includes(addon)) {
            onChange(selectedAddons.filter((a) => a !== addon));
        } else {
            onChange([...selectedAddons, addon]);
        }
    };

    return (
        <div>
            <h3>Research Add-ons</h3>
            <p style={{ marginBottom: 16, opacity: 0.7 }}>
                Optional deep-dive modules to enhance your brief.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                {Object.values(BriefAddon).map((addon) => (
                    <Card
                        key={addon}
                        size="small"
                        hoverable
                        style={{
                            cursor: "pointer",
                            borderColor: selectedAddons.includes(addon) ? "#1890ff" : undefined,
                        }}
                        onClick={() => handleToggle(addon)}
                    >
                        <Checkbox
                            checked={selectedAddons.includes(addon)}
                            onChange={() => handleToggle(addon)}
                        >
                            <strong>{BRIEF_ADDON_LABELS[addon]}</strong>
                        </Checkbox>
                        <p style={{ margin: "8px 0 0 24px", fontSize: 12, opacity: 0.7 }}>
                            {ADDON_DESCRIPTIONS[addon]}
                        </p>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default AddonSelectionStep;
